<alert [nom]="NOM_ALERTE_ERREUR_PREFERENCES" class="alerte" nomBouton="GLOBAL.OUI"></alert>


<div class="preferences-utilisateur">
	<span class="nom-utilisateur">{{ utilisateurConnecte.firstName }} {{ utilisateurConnecte.lastName }}</span>

	<div class="preferences-menu-content">
		<div class="menu-preferences">
			<p-menu [model]="items">
				<ng-template pTemplate="submenuheader" let-item>
					<span class="text-primary font-bold submenu-header-preferences">{{ item.label }}</span>
					<p-divider/>
				</ng-template>
				<ng-template pTemplate="item" let-item>
					<a pRipple class="flex align-items-center p-menuitem-link" [ngClass]="{'preference-active': isActiveMenuItem(item)}">
						<span [class]="item.icon"></span>
						<span class="ml-2">{{ item.label }}</span>
					</a>
				</ng-template>
			</p-menu>
		</div>

		<div class="preferences-content">
			@if (loadingPreferencesUtilisateur()) {
				<div class="spinner">
					<div class="app-spinner"></div>
				</div>
			} @else {
				<span class="titre-contenu-section">{{ titreSection() }}</span>
				<p-divider/>
				@switch (activeIndex()) {
					@case (0) {
						<div class="afficher-weekend">
							<label class="label-width">{{ 'PREFERENCES.LABEL_AFFICHER_WEEKEND' | translate }}</label>
							<p-inputSwitch
									[ngModel]="afficherWeekend()"
									(ngModelChange)="toggleAfficherWeekend($event)"/>
						</div>
					}
					@case (1) {
						<div class="reservation-preferences">
							<div class="section-preferences">
								<span class="titre-section">{{ 'SELECTION_ZONE.ZONE_PAR_DEFAUT' | translate }}</span>
								<div class="section-zone-par-defaut">
									<app-selection-zone
											[mode]="Mode.Modification"
											[loading]="loadingSelectionZone()"
											[zoneSelectionneeId]="zoneDeTravailParDefautId()"
											[afficherTitre]="false"
											(notifierZoneSelectionneeId)="onZoneSelectionnee($event)"/>
								</div>
							</div>
							<div class="information-bureau-preferentiel section-preferences">
								<span class="titre-section">{{ 'PREFERENCES.TITRE_PANEL_BUREAU_PREFERENTIEL' | translate }}</span>
								@if (loadingBureauPreferentiel()) {
									<div class="spinner">
										<div class="app-spinner"></div>
									</div>
								} @else {
									@if (isNotNullOrUndefined(bureauPreferentiel)) {
										<div class="header-information-bureau-preferentiel">
											<div>
												<span class="label-information">{{ 'PREFERENCES.LABEL_ZONE_DE_TRAVAIL' | translate }}</span>
												@if (loadingIlot()) {
													<p-skeleton width="10rem" styleClass="mb-2" borderRadius="16px"/>
												} @else if (isNotNullOrUndefined(nomZoneDeTravail)) {
													<span class="valeur-information">{{ nomZoneDeTravail }}</span>
												}
											</div>
											<div>
												<span class="label-information">{{ 'PREFERENCES.LABEL_ILOT' | translate }}</span>
												@if (loadingIlot()) {
													<p-skeleton width="10rem" styleClass="mb-2" borderRadius="16px"/>
												} @else if (isNotNullOrUndefined(nomIlot) && isNotNullOrUndefined(couleurIlot)) {
													<div class="information-ilot"
														 [style.background-color]="couleurIlot">
														<span class="valeur-information">{{ nomIlot }}</span>
													</div>
												}
											</div>
											<div>
												<span class="label-information">{{ 'PREFERENCES.LABEL_BUREAU' | translate }}</span>
												<span class="valeur-information">{{ bureauPreferentiel.nom }}</span>
											</div>
										</div>
										<div class="affichage-ilot" #containerAffichageIlot>
											@if (loadingIlot()) {
												<p-skeleton width="43rem" height="15rem" borderRadius="16px"/>
											} @else {
												@if (isNotNullOrUndefined(ilot())) {
													<app-grid-ilots
															[ilots]="[ilot()]"
															[readonly]="true"
															[longueurParent]="containerAffichageIlot.offsetWidth"
															[hauteurParent]="containerAffichageIlot.offsetHeight"
															[bureauPreferentielId]="bureauPreferentiel.id"
															[utilisateurConnecte]="utilisateurConnecte"
															[estAffichagePlusieursIlots]="false"
															[estAffichageVertical]="false"
															[labelHaut]="labelHaut()"
															[labelBas]="labelBas()"
															[labelDroite]="labelDroite()"
															[labelGauche]="labelGauche()"
															[estAfficherLabelIlot]="false"/>
												}
											}
										</div>
									} @else {
										<span>{{ 'PREFERENCES.AUCUN_BUREAU_PREFERENTIEL' | translate }}</span>
									}
								}
							</div>
						</div>
					}
				}
			}
		</div>
	</div>

</div>
